// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"dea5028e","455":"24e4e462","977":"60d69bf3"}[chunkId] + ".chunk.js";
};